// Module
var code = "<iframe class=\"class-designer\" ng-src=\"{{ $ctrl.src }}\" frameborder=\"0\"></iframe> ";
// Exports
export default code;